import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildBundleUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.NOTIFIES}${
    endpoint && endpoint.toString().length > 0 ? `/${endpoint}` : ""
  }`

const serializeParams = (params) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return
    if (Array.isArray(value)) {
      if (value.length === 0) return
      value.forEach((v) => searchParams.append(`${key}[]`, v))
    } else if (value !== 0 && value !== "") {
      searchParams.append(key, value)
    }
  })

  return searchParams.toString()
}

export const notifiesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatNotifies: builder.query({
      query: (params) => ({
        url: `${buildBundleUrl("list_combined")}?${serializeParams(params)}`,
        method: "GET",
      }),
    }),

    getChatDetail: builder.query({
      query: (params) => ({
        url: buildBundleUrl(`chat-detail/${params.bundle_id}`),
        method: "GET",
      }),
    }),

    // POST /book/bundle_notifies/create
    createNotify: builder.mutation({
      query: ({
        bundle_id,
        message,
        type,
        departament_id,
        provider_id,
        remote_order,
        files,
        for_admin,
        reply_to_id,
      }) => {
        const formData = new FormData()
        formData.append("bundle_id", bundle_id)
        formData.append("message", message)
        formData.append("for_admin", for_admin)
        if (type !== null) formData.append("type", type)
        if (departament_id !== null) formData.append("departament_id", departament_id)
        if (provider_id !== null) formData.append("provider_id", provider_id)
        if (remote_order !== null) formData.append("remote_order", remote_order)
        if (reply_to_id !== null) formData.append("reply_to_id", reply_to_id)

        if (files && files.length > 0) {
          files.forEach((file) => {
            formData.append("files[]", file)
          })
        }

        return {
          url: buildBundleUrl("create"),
          method: "POST",
          body: formData,
        }
      },
    }),

    // POST /book/bundle_notifies/set_read
    setNotifyRead: builder.mutation({
      query: (id) => ({
        url: buildBundleUrl("set_read"),
        method: "POST",
        body: { id },
      }),
    }),

    // POST /book/bundle_notifies/update_department
    updateNotifyDepartment: builder.mutation({
      query: ({ id, department_id }) => ({
        url: buildBundleUrl("update_department"),
        method: "POST",
        body: { id, department_id },
      }),
    }),

    updateNotifyMessage: builder.mutation({
      query: ({ id, message }) => ({
        url: buildBundleUrl("update_message"),
        method: "POST",
        body: { id, message },
      }),
    }),

    setReadChat: builder.query({
      query: (params) => ({
        url: buildBundleUrl("mark_read_v2"),
        method: "GET",
        params: params,
      }),
    }),

    setReadMessage: builder.mutation({
      query: (body) => ({
        url: buildBundleUrl("set_read"),
        method: "POST",
        body,
      }),
    }),

    setUnReadMessage: builder.mutation({
      query: (body) => ({
        url: buildBundleUrl("set_unread"),
        method: "POST",
        body,
      }),
    }),

    toggleReadMessage: builder.mutation({
      query: (id) => ({
        url: buildBundleUrl(`${id}/toggle_read`),
        method: "PATCH",
      }),
    }),

    getChatMeta: builder.query({
      query: () => ({
        url: buildBundleUrl("meta"),
        method: "GET",
      }),
    }),

    getListFlightChanges: builder.query({
      query: (params) => ({
        url: `${buildBundleUrl("list-flight-changes")}?${serializeParams(params)}`,
        method: "GET",
      }),
    }),

    getFlightChangesDetail: builder.query({
      query: (params) => ({
        url: buildBundleUrl(`flight-changes-detail/${params.bundle_id}`),
        method: "GET",
      }),
    }),
  }),
})

export const {
  useGetChatNotifiesQuery,
  useLazyGetChatNotifiesQuery,
  useLazyGetChatDetailQuery,
  useGetChatDetailQuery,
  useCreateNotifyMutation,
  useSetNotifyReadMutation,
  useUpdateNotifyDepartmentMutation,
  useUpdateNotifyMessageMutation,
  useSetReadChatQuery,
  useLazySetReadChatQuery,
  useSetReadMessageMutation,
  useSetUnReadMessageMutation,
  useToggleReadMessageMutation,
  useGetChatMetaQuery,
  useGetListFlightChangesQuery,
  useLazyGetListFlightChangesQuery,
  useLazyGetFlightChangesDetailQuery,
  useGetFlightChangesDetailQuery,
} = notifiesService
